// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"185":"0b039adc","352":"8b24f383","355":"d731e454","888":"4c0647ce","985":"bd239980"}[chunkId] + ".chunk.js";
};